import { hideLoader, showLoader } from "../../store/Loader/loader.slice"
import store from "../../store/store"

const openURL = async(url: any, action: 'open' | 'download', filename?: string) => {
    let element = document.createElement('a')
    element.style.display = 'none'
    element.href = url
    
    if (action === 'open') {
        element.target = '_blank'
        element.click()
    }
    
    if (action === 'download' && typeof filename !== 'undefined') {

        try {
            store.dispatch(showLoader('Downloading file...'))

            const response = await (await fetch(url)).blob()
            store.dispatch(hideLoader())
            element.download = filename
            element.href = URL.createObjectURL(response)
            element.target = '_blank'
            element.click()
        } catch (error) {
            store.dispatch(hideLoader())
            console.log(error)
        }
    }

    element.remove()
}

export default openURL